import { get } from 'utils/lodash'
import { formatDollarsToCents, formatCentsToDollars, formatDollarsToDecimalCents } from 'utils/price'
import { getTaxesForMaterial } from 'components/customer-details/content/work-orders/actions/disposal-ticket/utils'

export const getDisposalSiteDetails = (disposalSiteId, allSites) => {
  if (!disposalSiteId) return null

  return allSites.find(site => site.id === disposalSiteId)
}

export const getDisposalSiteMaterialDetails = (disposalSiteMaterials, disposalSiteMaterialId) =>
  disposalSiteMaterials.find(material => material.id === disposalSiteMaterialId)

export const getHasMinimumCharge = (useMinimumCharge, minimumCharge) => useMinimumCharge && minimumCharge > 0

export const getOverageFee = (quantity, overageWeight, overageFee) =>
  overageFee > 0 && Number(quantity) > Number(overageWeight) ? overageFee : 0

export const getAppliedRate = (useDisposalFeeRate, rate, unitPriceDollars) => (useDisposalFeeRate ? rate : unitPriceDollars)

export const getDisposalFeeDetails = (materials, taxes, disposalSiteMaterialsKeyBy) =>
  materials.map(material => {
    const disposalSiteMaterial = get(disposalSiteMaterialsKeyBy, material.disposalSiteMaterialId)
    const selectedMaterial = get(disposalSiteMaterial, 'material', {})
    const materialType = get(selectedMaterial, 'materialType', '')
    const materialColor = get(selectedMaterial, 'color', '')
    const quantity = get(material, 'quantity', 0)
    const useMinimumCharge = get(material, 'useMinimumCharge', false)
    const minimumCharge = useMinimumCharge ? get(material, 'minimumCharge', 0) : 0
    const minimumChargeCents = formatDollarsToCents(minimumCharge)
    const unitPriceDollars = get(material, 'unitPriceDollars', 0)
    const rate = get(material, 'rate')
    const useDisposalFeeRate = get(material, 'useDisposalFeeRate')
    const appliedRate = getAppliedRate(useDisposalFeeRate, rate, unitPriceDollars)
    const appliedRateCents = formatDollarsToDecimalCents(appliedRate)
    const includedTonnage = get(material, 'includedTonnage', 0)
    const chargeableTonnage = Math.max(quantity - includedTonnage, 0)
    const overageWeight = get(material, 'overageWeight', 0)
    const overageFee = getOverageFee(quantity, overageWeight, get(material, 'overageFee', 0))
    const overageFeeCents = formatDollarsToCents(overageFee)
    const subtotalCents = chargeableTonnage * appliedRateCents + minimumChargeCents + overageFeeCents
    const subtotalDollars = formatCentsToDollars(subtotalCents)
    const { taxesForMaterial, totalTaxCents } = getTaxesForMaterial(taxes, subtotalDollars)

    const tippingFeeSubtotal = quantity * unitPriceDollars
    const tippingFeeSubtotalCents = formatDollarsToCents(tippingFeeSubtotal)
    const { taxesForMaterial: tippingFeeTaxes, totalTaxCents: tippingFeeTotalTaxCents } = getTaxesForMaterial(taxes, tippingFeeSubtotal)

    return {
      ...material,
      materialType,
      materialColor,
      chargeableTonnage,
      tippingData: {
        subtotalCents: tippingFeeSubtotalCents,
        subtotalCentsWithTax: tippingFeeSubtotalCents + tippingFeeTotalTaxCents,
        totalTaxCents: tippingFeeTotalTaxCents,
        taxes: tippingFeeTaxes,
      },
      disposalFeeData: {
        subtotalCents,
        subtotalCentsWithTax: subtotalCents + totalTaxCents,
        totalTaxCents,
        taxes: taxesForMaterial,
      },
    }
  })
